import { Checkbox } from '@monash/portal-react';

const SubFilterCheckboxes = ({
  subFilters,
  isParentChecked,
  filtersFields,
  toggleCheckbox,
}) => {
  return Object.values(subFilters).map((subFilter) => {
    const { value, text } = subFilter;
    const index = filtersFields.findIndex((filter) => filter.value === value);
    const isChecked = index !== -1;

    return (
      <Checkbox
        key={value}
        on={isChecked}
        text={text}
        onChange={() => toggleCheckbox({ isChecked, value, index })}
        disabled={isParentChecked}
      />
    );
  });
};

export default SubFilterCheckboxes;
